export const HORIZONTAL = 'horizontal';
export const COLUMN = 'column';
export const COLUMN_REVERSE = 'column-reverse';